import { render, staticRenderFns } from "./ImportPayers.vue?vue&type=template&id=cfecdd1a&scoped=true"
import script from "./ImportPayers.vue?vue&type=script&lang=js"
export * from "./ImportPayers.vue?vue&type=script&lang=js"
import style0 from "./ImportPayers.vue?vue&type=style&index=0&id=cfecdd1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfecdd1a",
  null
  
)

export default component.exports